export default function EstrategiaCampanas() {
  const estrategias = [
    {
      id: 1,
      icon: 'ri-message-3-line',
      title: 'Copys Persuasivos',
      subtitle: 'Frameworks PAS y AIDA Integrados',
      description: 'No más bloqueo creativo. Nexus genera copys de venta probados usando las fórmulas más efectivas del marketing directo.',
      features: [
        'Estructura PAS (Problema-Agitación-Solución) lista para usar',
        'Modelo AIDA (Atención-Interés-Deseo-Acción) optimizado',
        'Ganchos emocionales que conectan con tu audiencia',
        'Llamados a la acción que generan respuestas inmediatas'
      ],
      color: '#FF6B00',
      bgColor: 'bg-[#FF6B00]/10',
      borderColor: 'border-[#FF6B00]/30'
    },
    {
      id: 2,
      icon: 'ri-whatsapp-line',
      title: 'Embudos para WhatsApp',
      subtitle: 'Configuración Paso a Paso',
      description: 'Convierte WhatsApp en tu máquina de ventas automática. Desde el primer mensaje hasta el cierre, todo está diseñado para convertir.',
      features: [
        'Secuencias de mensajes automatizadas para cada etapa',
        'Scripts de conversación que manejan objeciones',
        'Estrategias de seguimiento sin ser invasivo',
        'Plantillas de cierre que duplican tu tasa de conversión'
      ],
      color: '#25D366',
      bgColor: 'bg-[#25D366]/10',
      borderColor: 'border-[#25D366]/30'
    },
    {
      id: 3,
      icon: 'ri-user-search-line',
      title: 'Guías de Segmentación',
      subtitle: 'Encuentra a tu Cliente Ideal',
      description: 'Deja de vender a todo el mundo. Nexus te muestra exactamente quién necesita tu producto y cómo encontrarlos.',
      features: [
        'Perfiles de cliente ideal (ICP) basados en datos reales',
        'Criterios de segmentación por comportamiento y necesidades',
        'Estrategias de targeting para Facebook, Instagram y Google',
        'Mensajes personalizados para cada segmento de audiencia'
      ],
      color: '#00D9FF',
      bgColor: 'bg-[#00D9FF]/10',
      borderColor: 'border-[#00D9FF]/30'
    }
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-white relative overflow-hidden">
      
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-[#FF6B00]/5 rounded-full blur-[150px]"></div>
      <div className="absolute bottom-0 left-0 w-[350px] sm:w-[500px] h-[350px] sm:h-[500px] bg-[#00D9FF]/5 rounded-full blur-[150px]"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 px-4 sm:px-5 py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-4 sm:mb-6">
            <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
            <span className="text-[#FF6B00] text-xs sm:text-sm font-bold tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>
              MÁS QUE UN SOFTWARE
            </span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#0A0A0A] leading-tight mb-4 sm:mb-6 px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            No Solo Te Damos el <span className="text-[#FF6B00]">Producto</span>,<br />
            Te Damos la <span className="text-[#FF6B00]">Hoja de Ruta</span>
          </h2>
          
          <p className="text-base sm:text-lg lg:text-xl text-[#0A0A0A]/70 max-w-3xl mx-auto leading-relaxed px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Nexus incluye estrategias completas de venta directa y campañas para WhatsApp. 
            Desde el primer mensaje hasta el cierre, todo está diseñado para <strong className="text-[#0A0A0A] font-semibold">convertir visitantes en clientes</strong>.
          </p>
        </div>

        {/* Strategy Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {estrategias.map((estrategia) => (
            <div 
              key={estrategia.id}
              className={`bg-white rounded-2xl sm:rounded-3xl border-2 ${estrategia.borderColor} p-6 sm:p-8 shadow-[0_8px_32px_rgba(0,0,0,0.06)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.1)] transition-all duration-500 group cursor-pointer`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${estrategia.bgColor} rounded-2xl flex items-center justify-center mb-5 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${estrategia.icon} text-2xl sm:text-3xl`} style={{ color: estrategia.color }}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-black text-[#0A0A0A] mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {estrategia.title}
              </h3>

              {/* Subtitle */}
              <p className="text-xs sm:text-sm font-semibold mb-3 sm:mb-4" style={{ fontFamily: 'Poppins, sans-serif', color: estrategia.color }}>
                {estrategia.subtitle}
              </p>

              {/* Description */}
              <p className="text-sm sm:text-base text-[#0A0A0A]/70 leading-relaxed mb-5 sm:mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {estrategia.description}
              </p>

              {/* Features List */}
              <div className="space-y-2.5 sm:space-y-3">
                {estrategia.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-2.5 sm:gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-base sm:text-lg" style={{ color: estrategia.color }}></i>
                    </div>
                    <p className="text-xs sm:text-sm text-[#0A0A0A]/80 leading-snug" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {feature}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Visual Example Section */}
        <div className="bg-gradient-to-br from-[#FAF9F6] to-white rounded-2xl sm:rounded-3xl border-2 border-[#E0E0DE] p-6 sm:p-10 lg:p-12 shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
            
            {/* Left: Example Content */}
            <div>
              <div className="inline-block px-3 sm:px-4 py-1.5 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-4 sm:mb-6">
                <span className="text-xs sm:text-sm font-bold text-[#FF6B00]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  EJEMPLO REAL
                </span>
              </div>

              <h3 className="text-2xl sm:text-3xl font-black text-[#0A0A0A] mb-4 sm:mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Así Se Ve un Copy Generado por Nexus
              </h3>

              <div className="bg-white rounded-xl sm:rounded-2xl border-2 border-[#E0E0DE] p-5 sm:p-6 space-y-3 sm:space-y-4">
                {/* PAS Framework Example */}
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-6 h-6 bg-[#FF6B00]/10 rounded-lg flex items-center justify-center">
                      <span className="text-[#FF6B00] text-xs font-black" style={{ fontFamily: 'Poppins, sans-serif' }}>P</span>
                    </div>
                    <span className="text-xs font-bold text-[#0A0A0A]/60" style={{ fontFamily: 'Poppins, sans-serif' }}>PROBLEMA</span>
                  </div>
                  <p className="text-xs sm:text-sm text-[#0A0A0A]/80 leading-relaxed pl-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    "¿Cansado de perder tiempo buscando qué producto digital vender?"
                  </p>
                </div>

                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-6 h-6 bg-[#FF6B00]/10 rounded-lg flex items-center justify-center">
                      <span className="text-[#FF6B00] text-xs font-black" style={{ fontFamily: 'Poppins, sans-serif' }}>A</span>
                    </div>
                    <span className="text-xs font-bold text-[#0A0A0A]/60" style={{ fontFamily: 'Poppins, sans-serif' }}>AGITACIÓN</span>
                  </div>
                  <p className="text-xs sm:text-sm text-[#0A0A0A]/80 leading-relaxed pl-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    "Mientras tú adivinas, otros ya están facturando con nichos que la IA detectó en segundos."
                  </p>
                </div>

                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-6 h-6 bg-[#FF6B00]/10 rounded-lg flex items-center justify-center">
                      <span className="text-[#FF6B00] text-xs font-black" style={{ fontFamily: 'Poppins, sans-serif' }}>S</span>
                    </div>
                    <span className="text-xs font-bold text-[#0A0A0A]/60" style={{ fontFamily: 'Poppins, sans-serif' }}>SOLUCIÓN</span>
                  </div>
                  <p className="text-xs sm:text-sm text-[#0A0A0A]/80 leading-relaxed pl-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    "Nexus analiza miles de nichos en tiempo real y te muestra exactamente qué vender y cómo promocionarlo."
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Benefits List */}
            <div>
              <h4 className="text-xl sm:text-2xl font-black text-[#0A0A0A] mb-5 sm:mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Todo Incluido en Nexus:
              </h4>

              <div className="space-y-3 sm:space-y-4">
                {[
                  { icon: 'ri-file-text-line', text: 'Copys completos listos para copiar y pegar', color: '#FF6B00' },
                  { icon: 'ri-flow-chart', text: 'Diagramas de embudo con cada paso explicado', color: '#25D366' },
                  { icon: 'ri-chat-quote-line', text: 'Scripts de conversación para manejar objeciones', color: '#00D9FF' },
                  { icon: 'ri-target-line', text: 'Estrategias de segmentación por plataforma', color: '#FF6B00' },
                  { icon: 'ri-calendar-check-line', text: 'Calendarios de contenido pre-diseñados', color: '#25D366' },
                  { icon: 'ri-line-chart-line', text: 'Métricas clave para medir tu éxito', color: '#00D9FF' }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3 sm:gap-4 bg-white rounded-lg sm:rounded-xl border border-[#E0E0DE] p-3 sm:p-4 hover:border-[#FF6B00]/30 transition-colors">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: `${item.color}30` }}>
                      <i className={`${item.icon} text-xl sm:text-2xl`} style={{ color: item.color }}></i>
                    </div>
                    <p className="text-xs sm:text-sm font-semibold text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-base sm:text-lg text-[#0A0A0A]/70 mb-4 sm:mb-6 px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            No necesitas contratar copywriters, diseñadores ni consultores de marketing.
          </p>
          <p className="text-xl sm:text-2xl font-black text-[#0A0A0A] mb-6 sm:mb-8 px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Todo está incluido en <span className="text-[#FF6B00]">Nexus Digital Intelligence</span>
          </p>
          <button
            onClick={() => {
              const offerSection = document.getElementById('oferta-section');
              if (offerSection) {
                offerSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-[#FF6B00] text-white font-black rounded-full shadow-[0_8px_32px_rgba(255,107,0,0.4)] hover:shadow-[0_12px_40px_rgba(255,107,0,0.6)] hover:bg-[#e05e00] transition-all cursor-pointer text-base sm:text-lg leading-snug text-center"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            <span className="sm:hidden">Obtener Acceso Completo<br />— S/ 25</span>
            <span className="hidden sm:inline">Obtener Acceso Completo — S/ 25</span>
          </button>
        </div>

      </div>
    </section>
  );
}